module.exports = __webpack_public_path__ + "static/media/rounded-rect-tertiary.349bb8f0.png";